import type { ChartStyleOptions, ChartType } from '@/types';
import type { ChartDataOptionsInternal } from '@/chart-data-options/types';
import type { DesignOptions } from '../translations/types';

export type StyleToDesignOptionsTranslator = (
  styleOptions: ChartStyleOptions,
  dataOptions: ChartDataOptionsInternal,
) => DesignOptions;

const translators = new Map<ChartType, StyleToDesignOptionsTranslator>();

export const registerStyleToDesignOptionsTranslator = (
  chartType: ChartType,
  translator: StyleToDesignOptionsTranslator,
) => {
  translators.set(chartType, translator);
};

export const getStyleToDesignOptionsTranslator = (chartType: ChartType) => {
  return translators.get(chartType);
};

export const clearStyleToDesignOptionsTranslators = () => {
  translators.clear();
};

